import { IFiltrouserDashboard } from "../../../Interfaces/Users/UsersInterface";
import { GetStatusIntegracaoUauService } from "../../../Services/Geral/Darshboard";
import { ListarusuariosdashboardService } from "../../../Services/Users/UsersService";
import { Controller } from "../../Controller";

export const ListarusuariosdashboardController = (
    Filtros: IFiltrouserDashboard
) => Controller(ListarusuariosdashboardService(Filtros));

export function GetStatusIntegracaoUauController() {
    return Controller(GetStatusIntegracaoUauService());
}
